import React from 'react';

function Footer() {
    return (
        <footer style={{ background: '#333', color: '#fff', textAlign: 'center', padding: '20px'}}>
            <p>&copy; 2025 La On Massage. All rights reserved.</p>
            {/* ADDED NAP (Name, Address, Phone) FOR LOCAL SEO */}
            <p>
                La On Massage | (909) 767-3286 <br />
                9591 W Foothill Blvd, Rancho Cucamonga, CA 91730
            </p>
        </footer>
    );
}

export default Footer;